<template>

    <form ref="escolaestagio-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            
                    <div class="form-group col-md-12">
                        <label for="escolaId">EscolaBox</label>
                        <select v-select="{ dataitem: 'EscolaBox', default: 'Selecione' }" v-model="model.escolaId" class="form-control" name="escolaId" required></select>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="estagioId">Estagio</label>
                        <select v-select="{ dataitem: 'Estagio', default: 'Selecione' }" v-model="model.estagioId" class="form-control" name="estagioId" required></select>
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorMaterialDidaticoSugerido">ValorMaterialDidaticoSugerido</label>
                        <input type="text" class="form-control" name="valorMaterialDidaticoSugerido" placeholder="ValorMaterialDidaticoSugerido" v-model="model.valorMaterialDidaticoSugerido" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorEstagioSugerido">ValorEstagioSugerido</label>
                        <input type="text" class="form-control" name="valorEstagioSugerido" placeholder="ValorEstagioSugerido" v-model="model.valorEstagioSugerido" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorHoraSugerido">ValorHoraSugerido</label>
                        <input type="text" class="form-control" name="valorHoraSugerido" placeholder="ValorHoraSugerido" v-model="model.valorHoraSugerido" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorMaterialDidatico">ValorMaterialDidatico</label>
                        <input type="text" class="form-control" name="valorMaterialDidatico" placeholder="ValorMaterialDidatico" v-model="model.valorMaterialDidatico" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorEstagio">ValorEstagio</label>
                        <input type="text" class="form-control" name="valorEstagio" placeholder="ValorEstagio" v-model="model.valorEstagio" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorHora">ValorHora</label>
                        <input type="text" class="form-control" name="valorHora" placeholder="ValorHora" v-model="model.valorHora" required />
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="vendaLiberada" class="custom-control-input" v-model="model.vendaLiberada">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> VendaLiberada?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorEstagioRematricula">ValorEstagioRematricula</label>
                        <input type="text" class="form-control" name="valorEstagioRematricula" placeholder="ValorEstagioRematricula" v-model="model.valorEstagioRematricula" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorMaterialDidaticoRematricula">ValorMaterialDidaticoRematricula</label>
                        <input type="text" class="form-control" name="valorMaterialDidaticoRematricula" placeholder="ValorMaterialDidaticoRematricula" v-model="model.valorMaterialDidaticoRematricula" required />
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "escolaestagio-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "escolaestagio-form-create",
            
            resources: {
                create: 'escolaestagio',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

